export const SORT_ORDERS = ['asc', 'desc'] as const;

export type SortOrder = (typeof SORT_ORDERS)[number];

export const isSortOrder = (value: unknown): value is SortOrder =>
  SORT_ORDERS.some((order) => order === value);

// A sort string is parsed out of a query param, so its direction is a guess
// until it is checked.
export const toSortOrder = (value: string | undefined): SortOrder =>
  SORT_ORDERS.find((order) => order === value) ?? 'asc';

export type SortOption = {
  name: string;
  order: SortOrder;
};

export type SortObject = { [name: string]: SortOrder };
